module.exports = __webpack_public_path__ + "159de3ec5ada3e259ee07bb51981728b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/belt-black.png
// module id = 1234
// module chunks = 0